<template>
  <div class="checkbox">
    <input
      type="checkbox"
      :id="id"
      :name="name"
      class="checkbox__input"
      @input="$emit('input', $event.target.checked)"
      :disabled="disabled"
      :checked="value"
    />
    <label :for="id" class="checkbox__label">{{ label }}</label>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'bimCheckbox',
  props: {
    /**
     * Значение чекбокса
     * @model
     */
    value: Boolean,
    /**
     * Подпись (label) чек-бокса
     */
    label: {
      type: String,
      default: ''
    },
    /**
     * id чекбокса. Прописывается для input и label одинаковый
     */
    id: {
      type: String,
      default: 'checkbox'
    },
    /**
     * Имя инпута
     */
    name: {
      type: String,
      default: 'checkbox'
    },
    /**
     * Отключение чек-бокса
     */
    disabled: Boolean
  },
}
</script>

<style lang="scss" scoped>
  *, *::after, *::before {
    box-sizing: border-box;
  }

.checkbox {
  display: inline-flex;
  min-height: 20px;
  box-sizing: border-box;
}
.checkbox__input {
  display: none;
}
.checkbox__label {
  display: flex;
  align-items: center;
}

.checkbox__input + .checkbox__label {
  position: relative;

  padding: 0 0 0 24px;

  cursor: pointer;
  user-select: none;
  font-size: inherit;

  &:hover {
    &:before {
      border: solid 1px $primary-color-900;
    }
  }
}
.checkbox__input:checked + .checkbox__label {
  &:hover {
    &:before {
      background-color: $primary-color-900;
      border-color: $primary-color-900;
    }
  }
}

.checkbox__input + .checkbox__label:before,
.checkbox__input + .checkbox__label:after {
  content: "";
  position: absolute;
  top: 1px;
  left: 0;

  width: 16px;
  height: 16px;

  transition: 0.2s;
}

.checkbox__input + .checkbox__label:before {
  background-color: transparent;
  border: solid 0.0667rem $white-color-700;
  border-radius: 4px;
}

.checkbox__input + .checkbox__label:after {
  transform: scale(0);
  background: url("~@/assets/img/svg-css/input-check.svg") no-repeat
    50%;
}

.checkbox__input:checked + .checkbox__label:after {
  transform: scale(1);
}
.checkbox__input:checked + .checkbox__label:before {
  background-color: $primary-color;
  border-color: $primary-color;
}

.checkbox__input:disabled + .checkbox__label:before {
  background-color: $white-color-100;
  border: solid 0.0667rem $white-color-100;
}
</style>
